



























































































import { Component, Vue } from "vue-property-decorator";
import { apiService, Interfaces, AppConstants, Models } from "@/core/Export";
import store from "@/store";
@Component({
  components: {}
})
export default class ApprovalsList extends Vue {
  approvals: Array<any>;
  constructor() {
    super();
    this.approvals = new Array<any>();
  }

  created() {
    this.onGetApprovalsList();
  }

  onGetApprovalsList() {
    this.appEnv.isBusy = true;
    apiService
      .getApprovalsList(this.drawerParams.employeeId, this.drawerParams.isFromManager)
      .then(res => {
        let result: Interfaces.iServiceRequest = res;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.approvals = call.callResult.data;
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.appEnv.isBusy = false;
      })
      .catch(err => {
        this.appEnv.isBusy = false;
      });
  }

  onViewMonth(approval: any) {
    store.commit(AppConstants.StoreMutations.UpdateSelectedMonth, approval.month);
    store.commit(AppConstants.StoreMutations.UpdateSelectedYear, approval.year);

    if (this.drawerParams.isFromManager) {
      let employee = this.employeesList.find(s => s.id === approval.employeeId);
      if (employee) {
        store.commit(AppConstants.StoreMutations.UpdateCurrentEmployee, employee);
        this.$router.push({
          name: AppConstants.Routes.M_Employee_Details
        });
      }
    } else {
      if (this.appEnv.UserInfo.isManager) {
        this.$router.push({ name: AppConstants.Routes.M_PersonalArea });
      }
    }
    this.onCloseApprovalsListDrawer();
  }

  onCloseApprovalsListDrawer() {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, false);
    store.commit(AppConstants.StoreMutations.UpdateLeftDrawerComponnent, null);
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {});
  }

  isEmpApproveDateVisible(empAproveDate) {
    return this.appEnv.UserInfo.isManager && this.drawerParams.isFromManager && empAproveDate;
  }

  getEmployeeName(employeeId) {
    let employee = this.employeesList.find(s => s.id == employeeId);
    if (employee) return `${employee.lastName} ${employee.firstName}`;
  }

  onOrderByApprovalList() {
    this.approvals.sort((x, y) => x.year && x.month > y.year && y.month ? 1 : -1);
  }

  get isApprovalListEmpty() {
    return Object.keys(this.approvalsList).length == 0;
  }

  get approvalsList() {
    this.onOrderByApprovalList();
    if (this.drawerParams.isFromManager) {
      var groupedApprovals = this.approvals.reduce((obj: any, employee: any) => {
        obj[employee.employeeId] = obj[employee.employeeId] || [];
        let employeeName = obj[employee.employeeId].employeeName;
        if (employeeName == undefined) obj[employee.employeeId].employeeName = employee.employeeName;
        obj[employee.employeeId].push(employee);
        return obj;
      }, {});
      return groupedApprovals;
    } else {
      return this.approvals;
    }
  }

  get drawerParams() {
    return store.getters.drawerParams;
  }

  get employeesList() {
    return store.getters.employeesList;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
